import {useSyntheticChange} from '@github-ui/use-synthetic-change'
import {useCallback, useRef, useState} from 'react'

// Hook for handling markdown input
export function useInputManagement(onChange: (value: string) => void) {
  const inputRef = useRef<HTMLTextAreaElement>(null)
  const [inputKey, setInputKey] = useState(1)
  const inputHeight = useRef(0)

  if (inputRef.current && inputRef.current.offsetHeight) {
    inputHeight.current = inputRef.current.offsetHeight
  }

  const onInputChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange(e.target.value)
    },
    [onChange],
  )

  const reset = useCallback(() => {
    onChange('')
    setInputKey(key => key + 1)
  }, [onChange])

  const emitChange = useSyntheticChange({inputRef, fallbackEventHandler: onInputChange})

  return {
    inputRef,
    inputKey,
    inputHeight,
    onInputChange,
    reset,
    emitChange,
  }
}
